
import Panel from "components/panels/panel";
import React from "react";
import { useCredits } from "./useCredits";
import { Loading } from "components/panels";

export const CreditBalance = () => {
  const credits = useCredits();

  return <Panel
    panelClassName="s1_panel"
    title={<div className="header-title">{RESX.Credit.CreditBalance}</div>}
  >
    <div className="ui message purple">
      {credits != null && (<>{credits} credits left</>)}
      {credits == null && <Loading />}
    </div>
  </Panel>
}
